export default function StepperProceso({ activeStep }) {
  const steps = [
    {
      title: 'Plantilla',
      description: ''
    },
    {
      title: 'Validación',
      description: ''
    },
    {
      title: 'Procesamiento',
      description: 'Estamos emitiendo tus documentos. Si cierras esta ventana, el proceso continuará en segundo plano. Te notificaremos cuando finalice. Te recomendamos no recargar la página.'
    },
    {
      title: 'Reporte',
      description: 'Resultado final de la carga masiva y descarga de informes detallados.'
    }
  ]

  const currentStep = steps[activeStep] || steps[0]

  return (
    <div className='flex flex-col items-center justify-center bg-white mt-3'>
      {/* Píldora de encabezado */}
      <div className='inline-flex items-center justify-center px-6 py-1.5 rounded-full bg-slate-50 border border-slate-200 shadow-sm mb-3'>
        <span className='text-[13px] font-bold text-slate-800 tracking-tight'>
          Paso {activeStep + 1} de {steps.length} - {currentStep.title}
        </span>
      </div>

      {/* Descripción secundaria */}
      <p className='text-xs text-slate-500 text-center max-w-xl leading-relaxed'>
        {currentStep.description}
      </p>
    </div>
  )
}
